import React, { useEffect, useState } from 'react';
import cn from 'classnames';

import { ReactComponent as SearchIcon } from 'assets/imgs/search.svg';
import { ReactComponent as CaretIcon } from 'assets/imgs/caret-down.svg';
import Input from '../';
import classes from './select.module.scss';
import { IOption, ISelect } from './types';

const Select: React.FC<ISelect> = ({ 
	className,
	value,
	options,
	onSelect,
	onChange,
	placeholder,
	error,
	renderOption,
	isSearch,
	isFilter,
	isLoading,
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const [search, setSearch] = useState('');
	const filteredOptions = isFilter
		? options.filter((option) => option.label.toLowerCase().includes(search.toLowerCase()))
		: options;

	const handleChange = (inputValue: string): void => {
		onSelect(null);
		setSearch(inputValue);
		if (onChange) {
			onChange(inputValue);
		}
	};

	const handleSelect = (option: IOption) => (e: React.MouseEvent<HTMLDivElement>) => {
		e.stopPropagation();
		onSelect(option);
		setSearch('');
		setIsOpen(false);
	};

	const handleOpenOptions = (): void => {
		setIsOpen(true);
	};

	const handleCloseOptions = (): void => {
		setIsOpen(false);
	};

	useEffect(() => {
		document.addEventListener('click', handleCloseOptions);
		return () => {
			document.removeEventListener('click', handleCloseOptions);
		};
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const searchIcon = isSearch && <SearchIcon className={classes.iconSearch} />;

	const caretIcon = (
		<CaretIcon className={cn(classes.iconCaret, { [classes.iconCaret__open]: isOpen })} />
	);

	const renderOptions = (option: IOption): JSX.Element => (
		<div className={classes.option} key={option.value} onClick={handleSelect(option)}>
			{renderOption ? renderOptions(option) : option.label}
		</div>
	);

	return (
		<Input
			className={cn(classes.select, className, { [classes.select__search]: isSearch })}
			value={value?.label || search}
			onChange={handleChange}
			placeholder={placeholder}
			error={isOpen ? '' : error}
			onClick={handleOpenOptions}
			disabled={!isSearch}
			startIcon={searchIcon}
			endIcon={caretIcon}
			isLoading={isLoading}
		>
			{isOpen && !isLoading && filteredOptions.length > 0 && (
				<div className={classes.options}>
					{filteredOptions.map(renderOptions)}
				</div>
			)}
		</Input>
	);
};

export default Select;
